"use client";

/**
 * Hook to access theme mode and controls
 * 
 * @example
 * ```tsx
 * import { useTheme } from '@/app/hooks/useTheme';
 * 
 * function MyComponent() {
 *   const { mode, toggleTheme, setTheme } = useTheme();
 *   
 *   return (
 *     <button onClick={toggleTheme}>
 *       Current theme: {mode}
 *     </button>
 *   );
 * }
 * ```
 */
export { useTheme } from '../components/layoutManager';
export type { ThemeMode } from '../components/layoutManager';

